import { useMemo } from 'react'
import {useSelector} from 'react-redux'

const useExchange = () => {
    const broker = useSelector(state => state.account.broker)
    
    const exchange = useMemo(()=>{
      return broker?.broker?.exchange
    },[broker])

    return exchange
}

export default useExchange